<template>
  <div>
    <div class="top-bg-container" :style="{ backgroundImage: `url(${bgSrc})` }">
      <div class="divider"></div>
      <div class="text_container">
        <h1 class="title">{{ title }}</h1>
        <slot></slot>
      </div>
      <slot name='btn'></slot>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bgSrc: ''
    }
  },
  created () {
    this.iniBgImg()
  },
  methods: {
    iniBgImg () {
      // eslint-disable-next-line
      this.bgSrc = require(`@/assets/bg/${this.bgName}`)
    }
  },
  props: {
    title: String,
    bgName: String
  }
}
</script>

<style scoped>
.top-bg-container {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 512px;
  box-sizing: border-box;
  padding-top: 200px;
  position: relative;
}
.top-bg-container::before {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(10, 24, 41, .5);
}
.divider {
  margin: 0 auto;
  box-sizing: border-box;
  width: 100px;
  height: 6px;
  background: #bc9a41;
  border-radius: 4px;
  position: absolute;
  z-index: 1;
  top: 30%;
  left: calc(50% - 50px);
}
.title {
  font-size: 48px;
  text-align: center;
  font-weight: 500;
  text-transform: uppercase;
  color: #ffffff;
  line-height: 56px;
  margin-top: 20px;
  width: 100%;
  text-shadow: 0px 2px 20px rgba(0, 0, 0, 0.3);
}
.text_container{
  z-index: 1;
  position: absolute;
  width: min(60em, calc(100% - 48px));
  top: 35%;
  left: 50%;
  transform: translateX(-50%);
}
@media only screen and (max-width: 768px) {
.top-bg-container {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 300px;
  height: auto;
  box-sizing: border-box;
  padding: 110px 16px 40px;
}
.divider {
  margin: 0 auto;
  box-sizing: border-box;
  width: 20vw;
  height: 1.2vw;
  background: #bc9a41;
  border-radius: 4px;
  top: 30%;
  left: calc(50% - 10vw);
}
.title {
  font-size: 26px;
  text-align: center;
  font-weight: 500;
  text-transform: uppercase;
  color: #ffffff;
  line-height: 1.4;
  margin-top: 4vw;
  text-shadow: 0px 2px 20px rgba(0, 0, 0, 0.3);
}
.text_container{
  position: relative;
  left: auto;
  top: auto;
  transform: none;
  width: 100%;
  text-align: center;
}
}
</style>
